import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }
const _hoisted_3 = {
  class: "dropdown action-opt",
  style: {"right":"-1px"}
}
const _hoisted_4 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_5 = { style: {"margin":"-18px 0 -16px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-0" }, "Statistics", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          class: "btn bg-transparent p-0",
          type: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, [
          _createElementVNode("i", { class: "ri-more-fill fs-26 text-body lh-1" })
        ], -1)),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTimeRange('day')))
            }, " This Day ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTimeRange('week')))
            }, " This Week ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTimeRange('month')))
            }, " This Month ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTimeRange('year')))
            }, " This Year ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { id: "statistics_chart" }, null, -1)),
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "298",
            options: _ctx.statisticsChart,
            series: _ctx.statistics
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}